import { useEffect, useState } from "react";
import { McpDefaultIcon } from "../../../components/McpDefaultIcon";
import type { MCPConnection } from "../types";

type Props = {
  connection: Pick<
    MCPConnection,
    "name" | "icon" | "iconUrl" | "iconClassName"
  >;
  size?: "sm" | "md";
};

const SIZE_CLASS: Record<NonNullable<Props["size"]>, string> = {
  sm: "size-[42px] text-sm",
  md: "size-9 text-base",
};

const ConnectionIcon = ({ connection, size = "sm" }: Props) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [connection.iconUrl]);

  const showImage = Boolean(connection.iconUrl) && !imageFailed;
  const fallbackClass = connection.iconClassName ?? "bg-muted text-foreground";

  return (
    <span
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-md font-semibold ${SIZE_CLASS[size]} ${
        showImage ? "border border-border bg-white p-1.5" : fallbackClass
      }`}
    >
      {showImage ? (
        <img
          src={connection.iconUrl ?? undefined}
          alt=""
          className="size-6 object-contain"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <McpDefaultIcon className="size-6" />
      )}
    </span>
  );
};

export default ConnectionIcon;
